import { Stack, Typography, useTheme } from '@mui/material';

import { FC } from 'react';
import getConfig from 'next/config';
import { pxToRem } from '@/theme/typography';
import { useUserTypes } from '@/logic/hooks/use-user-types';

// Deploy-version marker: log it once per page load instead of on every render.
let hasLoggedDevelopersVersion = false;

export const EnvironmentInfo: FC = () => {
  const { publicRuntimeConfig } = getConfig();
  const theme = useTheme();
  const { userType } = useUserTypes();
  if (!hasLoggedDevelopersVersion) {
    hasLoggedDevelopersVersion = true;
    console.log(publicRuntimeConfig?.developersVersion);
  }
  return (
    publicRuntimeConfig?.environment !== 'production' && (
      <Stack
        direction='row'
        sx={{
          position: 'fixed',
          top: '4px',
          right: '0px',
          zIndex: 1201,
          alignItems: 'center',
          ':hover': {
            cursor: `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg'  width='50' height='60' viewport='0 0 100 100' style='fill:black;font-size:30px;'><text y='50%'>😎</text></svg>") 16 0,auto`,
          },
        }}
      >
        &nbsp;
        <Typography
          component='span'
          sx={{
            color: theme.palette.common.white,
            fontSize: pxToRem(10),
          }}
        >
          {userType} &nbsp; | &nbsp;
          {publicRuntimeConfig?.version}&nbsp;(
          {publicRuntimeConfig?.developersVersion}) &nbsp; &#124;
        </Typography>
        <Typography
          component='span'
          sx={{
            color: theme.palette.common.white,
            fontSize: pxToRem(10),
          }}
        >
          &nbsp; {publicRuntimeConfig?.environment}
        </Typography>
        &nbsp;&nbsp;&nbsp;
      </Stack>
    )
  );
};
